import React from "react";
import { useFormContext, useWatch } from "react-hook-form";

import {
  CountrySelectField,
  SelectField,
  TextField,
} from "components/AddVaccineForm/components";
import { PostCodeField } from "components/form/PostCodeField/PostCodeField";
import { isIrishCountry } from "utils/country";
import { counties } from "utils/patientFormOptions";

import s from "../PatientProfileForm.module.css";

export function PatientProfileAddressSection({ isCreate }) {
  const { control, setValue } = useFormContext();
  const sectionClass = isCreate ? s.sectionCreate : s.sectionEdit;
  const headerClass = isCreate ? s.sectionHeader : s.sectionHeaderEdit;

  const country = useWatch({ control, name: "country" });
  const isIrishAddress = isIrishCountry(country);

  return (
    <div className={sectionClass}>
      <h3 className={headerClass}>Address</h3>
      <div className={s.formGrid}>
        <TextField
          name="addressLine1"
          label="Address Line 1 *"
          placeholder="Enter address line 1"
          ariaRequired
        />
        <TextField
          name="addressLine2"
          label="Address Line 2"
          placeholder="Enter address line 2"
        />
        <TextField
          name="addressLine3"
          label="Address Line 3"
          placeholder="Enter address line 3"
        />
      </div>
      <div className={`${s.formGrid4} ${s.addressCountyPostCityCountry}`}>
        {/* The 26 Irish counties are the wrong list for an address abroad — offering them
            invites a Dublin on a French address, and a free-text region is the only honest
            control. County stays mandatory for an Irish address because the HL7 address
            maps it to XAD.4, and a lab order is refused without it (KIN-1650). */}
        {isIrishAddress ? (
          <SelectField
            name="county"
            label="County *"
            options={counties}
            placeholder="Select"
            onChange={(value) => {
              setValue("county", value);
            }}
            ariaRequired
          />
        ) : (
          <TextField
            name="county"
            label="County / Region"
            placeholder="Enter county or region"
          />
        )}

        {/* Only Ireland has Eircodes. Calling a foreign postcode one is wrong on the label
            and wrong in the validation, which rejects anything that is not the Irish
            routing-key format. */}
        <PostCodeField
          name="postCode"
          label={isIrishAddress ? "Eircode" : "Postcode"}
          placeholder={isIrishAddress ? "Enter Eircode" : "Enter postcode"}
          formatAsEircode={isIrishAddress}
        />

        <TextField name="city" label="City" placeholder="Enter city" />
        <CountrySelectField
          name="country"
          label="Country"
          placeholder="Search country"
          ariaRequired
        />
      </div>
    </div>
  );
}
